import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export default function YesNoControl(props) {
  return (
    <ToggleButtonGroup
      color="secondary"
      value={props.value}
      exclusive
      onChange={(e, newAlignment) => props.onChange(props.id, newAlignment)}
      aria-label="Platform"
    >
      <ToggleButton value="Yes">Yes</ToggleButton>
      <ToggleButton value="No">No</ToggleButton>
      {props.showNa && <ToggleButton value="N/A">N/A</ToggleButton>}
    </ToggleButtonGroup>
  );
}
